module.exports = __webpack_public_path__ + "static/media/logo-en.7ff5d270.png";